export function getMonthValue(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${year}-${month}`;
}

export function getPreviousMonthValue(date = new Date()) {
  return getMonthValue(new Date(date.getFullYear(), date.getMonth() - 1, 1));
}

export function formatMonthLabel(value) {
  const [year, month] = String(value || "").split("-");
  if (!year || !month) return value || "";
  return `${year}年${Number(month)}月`;
}

export function buildMonthOptions({ monthsBack = 36, monthsForward = 12, baseDate = new Date() } = {}) {
  const options = [];
  const start = new Date(baseDate.getFullYear(), baseDate.getMonth() + monthsForward, 1);
  const totalMonths = monthsBack + monthsForward + 1;

  for (let index = 0; index < totalMonths; index += 1) {
    const date = new Date(start.getFullYear(), start.getMonth() - index, 1);
    const value = getMonthValue(date);
    options.push({ value, label: formatMonthLabel(value) });
  }

  return options;
}

export default function MonthSelect({
  value,
  onChange,
  dataTestId,
  showAllOption = false,
  allLabel = "全部月份",
  className = "",
  monthsBack = 36,
  monthsForward = 12,
  formatLabel = formatMonthLabel,
}) {
  const monthOptions = buildMonthOptions({ monthsBack, monthsForward });

  return (
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={className}
      data-testid={dataTestId}
    >
      {showAllOption && <option value="">{allLabel}</option>}
      {monthOptions.map((month) => (
        <option key={month.value} value={month.value}>
          {formatLabel(month.value)}
        </option>
      ))}
    </select>
  );
}
